<template>
    <md-card class="tour-card" v-bind:class="{'item-checked' : isChecked()}">
        <md-ripple>
            <md-card-media @click.native="tourChecked(tour.activeInactiveImages), tourCheckedIncomplete(tour.activeInactiveImages)" class="tourCheckedCss">
                <span class="select-tour material-icons" role="button"></span>
            </md-card-media>
            <img class="navigateToEditorImages" @click="navigateToEditor()" :src="getImageSrc(tour.card)">
            <md-card-content>
                <a class="no-line" @click="navigateToEditor()">
                    <span v-if="tour.activeInactiveImages === 1">
                        <h3><img class="completeImages" src="static/img/complete.png">{{ tour.name }}</h3>
                    </span>
                    <span v-else>
                        <h3><img class="inCompleteImages" style="width :13px" src="static/img/inComplete.png">{{ tour.name }}</h3>
                    </span>
                    <h4 class="tourDescription">{{ tour.description }}</h4>
                </a>
                <md-menu class="upload-btn" style="float: right;   margin-top: -20%; " v-if="showThreeDots" md-size="big" md-direction="bottom-end">
                    <md-button class="md-icon-button" md-menu-trigger>
                        <md-icon>more_vert</md-icon>
                        <md-menu-content class="mdMenuContent">
                            <md-menu-item v-if="checkedIncomCom === 0 || currentClient.compIncomStatus === 1">
                                <md-button class="export-button " @click="openDialogForSingle('export')">EXPORT</md-button>
                            </md-menu-item>
                            <md-menu-item v-if="checkedIncomCom === 0 || checkedIncomCom === 1 ||  currentClient.compIncomStatus === 1">
                                <md-button class="export-button " @click="copyToursAndCreateNew(tour.id)">COPY TOUR</md-button>
                            </md-menu-item>
                            <md-menu-item>
                                <form id="tourImage" enctype="multipart/form-data">
                                    <md-button class="export-button "><label for="files" class="md-button">CHANGE TOUR IMAGE </label></md-button>
                                    <input class="file-input" accept="image/*" type="file" id="files" ref="files" v-on:change="handleFileUpload($event,tour.id)"/>
                                </form>
                            </md-menu-item>
                            <md-menu-item style="    margin-left: 39px;">
                                <md-button class="md-icon-button" @click="openDialogForSingle('delete')">
                                    <md-icon>delete</md-icon>
                                </md-button>
                            </md-menu-item>
                        </md-menu-content>
                    </md-button>
                </md-menu>
            </md-card-content>
        </md-ripple>
    </md-card>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {EventBus} from './event-bus.js';

export default {
  props: {
    tour: {type: Object, required: true},
    index: {type: Number, required: true}
  },
  data: () => ({
    showThreeDots: false,
    incompletGetDelete: ''
  }),
  computed: {
    ...mapGetters('tours', ['checked', 'redCount']),
    ...mapGetters('client', ['currentClient']),
    checkedIncomCom () {
      return this.redCount;
    }
  },
  methods: {
    ...mapActions('tours', ['loadTourEditor', 'mutateCheckedList', 'checkComIncomp', 'closeExportModal']),
    ...mapActions('map', ['setCenter']),
    getImageSrc (image) {
      if (image) {
        if (image.substring(0, 5) !== 'https') {
          return 'static/img/dev/' + image;
        } else {
          return image;
        }
      } else {
        return 'static/img/dev/default-tour.png';
      }
    },
    tourChecked (param) {
      var passData = {indexFor: this.index, incompletComplete: param};
      this.mutateCheckedList(passData);
      this.showThreeDots = true;
    },
    tourCheckedIncomplete (param) {
      var passData = {indexFor: this.index, incompletComplete: param};
      this.checkComIncomp(passData);
      this.incompletGetDelete = param;
    },
    isChecked () {
      for (var i = 0; i < this.checked.length; i++) {
        if (this.checked[i] === this.index) {
          return true;
        }
      }
      this.showThreeDots = false;
      return false;
    },
    navigateToEditor () {
      this.closeExportModal();
      this.loadTourEditor(this.tour);
      this.setCenter(this.tour);
      this.$router.push('/tour');
    },
    openDialogForSingle (param) {
      EventBus.$emit('openDialogForSingle', param);
    },
    copyToursAndCreateNew (param) {
      this.showThreeDots = false;
      this.$parent.copyAtoursAndCreateNewTour(param);
    },
    changeToursImages (tourID) {
      this.$parent.changeToursImagesParent(tourID);
    },
    handleFileUpload (event, tourID) {
      this.$parent.changeToursImagesParent(event.target.files[0], tourID);
    }
  }
};
</script>
<style scoped lang="scss">
.file-input {
    position: absolute !important;
    height: 100% !important;
    width: 100% !important;
    top: 25% !important;
    left: 30% !important;
    opacity: 0 !important;
}

.no-line {
    text-decoration-line: none;
}

.md-ripple {
    display: contents !important;
}

.md-card {
    box-shadow: none !important;
}

.md-card-content {
    padding: 12px 0px 0px 0px !important;
}

.export-button {
    margin: 14px 0 14px 8px;
    color: rgba(255, 255, 255, 0.87);
    background-color: rgb(0, 168, 202);
}

.export-button:hover {
    margin: 14px 0 14px 8px;
    color: rgba(255, 255, 255, 0.87);
    background-color: rgb(0, 168, 202);
}

.md-card a {
    color: black !important;
}

.md-card a:hover {
    color: black !important;
    text-decoration: none !important;
}

.tourCard {

}

.completeImages {
    width: 14px;
    margin-right: 10px;
}

.tourDescription {
    margin-left: 19px;
}

.tourCheckedCss {
    position: absolute !important;
    width: 97px !important;
    height: 71px !important;
}

.navigateToEditorImages {
    width: 310px !important;
    height: 160px !important;
    overflow: hidden !important;
    position: relative !important;
    margin: -1px -1px !important;
    max-width: 100% !important;
}

.mdMenuContent {
    width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/client/TourCard.vue